import * as React from "react";
import styled from "styled-components";
import { Button, ButtonProps, IconRight } from "./Button";
import { LoadingState } from "./states/LoadingState";
import { style } from "./style";

export type SpinnerButtonProps = ButtonProps & {
  className?: string;
  spinning?: boolean;
  inline?: boolean;
  loadingMessage?: string;
  loadingMessageAlignment?: "flex-start" | "center";
};

// This styled component is intentionally empty so we have something to export
// and use as a child selector elsewhere when necessary.
export const StyledSpinnerButton = styled(Button)`
  ${IconRight} {
    order: 1;
  }
`;

export const LoadingMessageWrapper = styled.div<{
  loadingMessageAlignment: string;
}>`
  margin-top: ${style.vars.space["3"]};
  display: flex;
  justify-content: ${({ loadingMessageAlignment }) => loadingMessageAlignment};
  align-items: ${({ loadingMessageAlignment }) => loadingMessageAlignment};
`;

const LoaderInline = styled(LoadingState)`
  margin: 0 0 0 ${style.vars.space["2"]};
  height: 1.25rem;
  width: 1.25rem;
  order: 2;
  color: currentColor;
`;

const LoadingMessageCopy = styled.span`
  display: inline-block;
  margin-left: ${style.vars.space["3"]};
`;

const DEFAULT_TYPE = "submit";
const DEFAULT_LOADING_MESSAGE_ALIGNMENT = "center";

export const SpinnerButton: React.FC<SpinnerButtonProps> = (props) => (
  <>
    <StyledSpinnerButton {...props} type={props.type || DEFAULT_TYPE} disabled={props.disabled || props.spinning}>
      {props.children} {props.spinning && props.inline && <LoaderInline />}
    </StyledSpinnerButton>

    {props.spinning && props.loadingMessage && !props.inline && (
      <LoadingMessageWrapper loadingMessageAlignment={props.loadingMessageAlignment || DEFAULT_LOADING_MESSAGE_ALIGNMENT}>
        <LoadingState />
        <LoadingMessageCopy>{props.loadingMessage}</LoadingMessageCopy>
      </LoadingMessageWrapper>
    )}

    {props.spinning && !props.loadingMessage && !props.inline && (
      <LoadingMessageWrapper loadingMessageAlignment={props.loadingMessageAlignment || DEFAULT_LOADING_MESSAGE_ALIGNMENT}>
        <LoadingState />
      </LoadingMessageWrapper>
    )}
  </>
);
